import { render, staticRenderFns } from "./Kassa.vue?vue&type=template&id=032d506d&"
import script from "./Kassa.vue?vue&type=script&lang=js&"
export * from "./Kassa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports